export default __webpack_public_path__ + "static/media/27.9c5b3666.jpg";